<footer id="footer">
  <div class="footer-top">
    <div class="container">
      <div class="row">
        <div class="col-lg-3 col-md-6 footer-info">
          <h3>
            <img
              src="../../../../../assets/img/brand/white.png"
              alt=""
              srcset=""
            />
          </h3>
          <p>
            Whatever may be your requirement - be it a simple website design, a
            complex data driven web application development, an ecommerce
            website, a native or cross platform mobile app development, a logo
            and brand identity design, a video production or a full fledged
            digital marketing campaign - we have a solution for you.
          </p>
        </div>

        <div class="col-lg-3 col-md-6 footer-links">
          <h4>Useful Links</h4>
          <ul>
            <li>
              <i class="fa fa-chevron-right"></i> <a routerLink="/">Home</a>
            </li>
            <li>
              <i class="fa fa-chevron-right"></i>
              <a routerLink="/service">Services</a>
            </li>
            <li>
              <i class="fa fa-chevron-right"></i>
              <a routerLink="/packages">Packages</a>
            </li>
            <li>
              <i class="fa fa-chevron-right"></i>
              <a routerLink="/portfolio">Portfolio</a>
            </li>
            <li>
              <i class="fa fa-chevron-right"></i>
              <a routerLink="/about">About us</a>
            </li>
            <li>
              <i class="fa fa-chevron-right"></i>
              <a routerLink="/about/contact-us">Contact us</a>
            </li>
            <li>
              <i class="fa fa-chevron-right"></i>
              <a routerLink="/auth/login">Login</a>
            </li>
          </ul>
        </div>

        <div class="col-lg-3 col-md-6 footer-contact">
          <h4>Contact Us</h4>
          <p>
            <i class="fa fa-location-arrow" aria-hidden="true"></i> D-108, Manak
            Vihar,Patel Nagar, <br />
            <span style="margin-left: 15px;"></span>
            Bhopal, MP, India (462022) <br />
            <strong><i class="fa fa-phone" aria-hidden="true"></i></strong>
            <a href="tel:918539082232"> +91 8539082232</a><br />
            <i class="fa fa-phone-square" aria-hidden="true"></i>
            <a href="tel:07554949433"> 0755-4949433</a><br />
            <i class="fa fa-envelope-open" aria-hidden="true"></i>
            <a href="mailto:info@webcaresoftwares.com">
              info@webcaresoftwares.com</a
            ><br />
          </p>
          <h4 style="margin-top: 10px;">Working Hour</h4>
          <p>
            Mon-Fri: 9:00 AM - 5:00PM <br />
            For Regular Client 24*7
          </p>

          <div class="social-links">
            <a href="#" target="_blank" title="Follow Us" class="twitter"
              ><i class="fa fa-twitter"></i
            ></a>
            <a href="#" target="_blank" title="Like Us" class="facebook"
              ><i class="fa fa-facebook"></i
            ></a>
            <a
              href="https://www.instagram.com/webcaresoftwares"
              target="_blank"
              title="Follow Us"
              class="instagram"
              ><i class="fa fa-instagram"></i
            ></a>
            <a href="#" target="_blank" title="Follow Us" class="google-plus"
              ><i class="fa fa-google-plus"></i
            ></a>
            <a href="#" target="_blank" title="Follow Us" class="linkedin"
              ><i class="fa fa-linkedin"></i
            ></a>
          </div>
        </div>

        <div class="col-lg-3 col-md-6 footer-newsletter">
          <h4>Our Newsletter</h4>
          <p>Enter your email ID below to subscribe to our newsletter.</p>
          <form action="" method="post">
            <input type="email" name="email" /><input
              type="submit"
              value="Subscribe"
            />
          </form>
          <h4 style="margin-top: 20px;">We Accept</h4>
          <!-- <p>Click the icon below which Payment Mode you want to pay us</p> -->
          <div class="row">
            <div class="col-lg-6">
              <img
                src="../../../../../assets/img/icons/payment-icon/paypal_upi.svg"
                alt=""
                srcset=""
              />
            </div>
            <div class="col-lg-6">
              <img
                src="../../../../../assets/img/icons/payment-icon/cards.svg"
                alt=""
                srcset=""
              />
            </div>
            <div class="col-lg-12">
              <a
                href="//www.dmca.com/Protection/Status.aspx?ID=13d337a2-efc7-4894-873f-cc63c751136c"
                title="DMCA.com Protection Status"
                class="dmca-badge"
                target="_blank"
              >
                <img
                  src="https://images.dmca.com/Badges/dmca-badge-w150-5x1-10.png?ID=13d337a2-efc7-4894-873f-cc63c751136c"
                  alt="DMCA.com Protection Status"
              /></a>
              <script src="https://images.dmca.com/Badges/DMCABadgeHelper.min.js"></script>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <hr
    style="
      height: 0.3px;
      background-color: rgb(70, 68, 68);
      margin: 0;
      padding: 0;
    "
  />
  <div class="container">
    <div class="copyright">
      &copy; Copyright 2020 All rights reserved to
      <span class="blinking">
        <i class="fa fa-heart" aria-hidden="true"></i>
      </span>
      <strong>WEBCARE SOFTWARES</strong>
      | <a href="">Terms & Conditions </a> | <a href="">Privacy Policy</a> |
      <a href="">Sitemap</a>
    </div>
  </div>
</footer>
<!-- End Footer -->
